import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import "./userManagement.scss";
import { dateFormat } from "utils/dateFormat";
import { userDetailApi } from "services/user";
import { FaCoins, FaEdit } from "react-icons/fa";
import { coinIcon, userPlaceholder } from "assets/icons";
import OrderHistory from "./section/orderHistory/OrderHistory";
import CoinHistory from "./section/CoinHistory";
import RefillSchedule from "./section/refillSchedule/RefillSchedule";
import ApprovedMedicines from "./section/approveMedicine/ApprovedMedicines";
import { TbTruckDelivery } from "react-icons/tb";
import BlockUnblockUser from "./BlockUnblockUser";
import { CgBlock, CgUnblock } from "react-icons/cg";
import { IoChevronBack } from "react-icons/io5";

const UserManagementDetails = () => {
  const { userId } = useParams();
  const navigate = useNavigate();

  const [userData, setUserData] = useState({});
  const [activeTab, setActiveTab] = useState("orders");

  const [userDetail, selectedUserDetail] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  // console.log('userData', userData)
  // --------handle-tabs------------
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  // -----close model

  const closeModel = () => {
    selectedUserDetail({});
    setStatusModal(false);
  };
  // ------------------------
  const fetchSelectedUserDetails = async () => {
    try {
      const {
        data: { status, code, data },
      } = await userDetailApi(userId);
      if (status || code === 200) {
        setUserData(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSelectedUserDetails();
  }, []);

  return (
    <div className="user-mgm-details-container">
      <div className="link-header-holder">
        <p>
          <Link to={-2}>
          <IoChevronBack />
            Back
          </Link>
          <span>User Management</span>
          &nbsp;
          <span>/ User Details</span>
        </p>

        <div>
          <button
            type="button"
            onClick={() => {
              navigate(`/user-management/edit/${userId}`);
            }}
          >
            <FaEdit />
          </button>
        </div>
        {/* <button
          type="button"
          onClick={() => {
            selectedUserDetail(userData);
            setStatusModal(true);
          }}
          disabled={userData?.status === "DELETED"}
        >
          {userData?.status === "BLOCKED" ? (
            <CgBlock style={{ color: "red" }} />
          ) : (
            <CgUnblock />
          )}
        </button> */}
      </div>

      <div className="card">
        <div className="userDetails-container">
          <div className="left-side">
            <div className="img-container">
              <img
                src={userData?.image || userPlaceholder}
                alt={userData?.fullName}
              />
              {/* <img
                  src="https://ride-chef-dev.s3.ap-south-1.amazonaws.com/sindhi/images/1748518433861-truckdriver.jpeg"
                  alt="user"
                /> */}
            </div>
            <p>{userData?.customerId}</p>
          </div>

          <div className="right-side">
            <div className="has_child mb-4">
              <h3 className="d-flex mb-0 w-75">
                Personal Details
                <span
                  style={{
                    backgroundColor: "#774DA9",
                    color: "#fff",
                    padding: "5px 15px",
                    borderRadius: "16px",
                    marginLeft: "20px",
                    fontSize: "18px",
                  }}
                >
                  <img src={coinIcon} alt="coin" className="me-3 " />
                  {userData?.totalCoins} coins
                </span>
              </h3>

              <div className="button_wrap button_right w-25">
                <button
                  type="button"
                  className="button"
                  onClick={() => {
                    selectedUserDetail(userData);
                    setStatusModal(true);
                  }}
                  disabled={userData?.status === "DELETED"}
                >
                  {userData?.status === "BLOCKED" ? "Unblock" : "Block"}
                </button>
              </div>
            </div>

            <ul>
              <li>
                <span>
                  <b>Name:</b>{" "}
                </span>{" "}
                <span>{userData?.fullName || "N/A"}</span>
              </li>
              <li>
                <span>
                  <b>Mobile Number:</b>{" "}
                </span>{" "}
                <span>
                  {userData?.countryCode && userData?.phone
                    ? `${userData?.countryCode} ${userData?.phone}`
                    : "N/A"}
                </span>
              </li>
              {/* <li><span>Alternate Mobile: </span> <span>{userData?.countryCode} {userData?.phone}</span></li> */}
              <li>
                <span>
                  <b>Email Address:</b>{" "}
                </span>{" "}
                <span>{userData?.email || "N/A"}</span>
              </li>
              <li>
                <span>
                  <b>DOB:</b>{" "}
                </span>{" "}
                <span>{userData?.dob || "N/A"}</span>
              </li>
              <li>
                <span>
                  <b>Gender:</b>{" "}
                </span>{" "}
                <span>{userData?.gender || "N/A"}</span>
              </li>
              <li>
                <span>
                  <b>Marital Status:</b>{" "}
                </span>{" "}
                <span>{userData?.martialStatus || "N/A"}</span>
              </li>
              <li>
                <span>
                  <b>Joined On:</b>{" "}
                </span>{" "}
                <span>{dateFormat(userData?.createdAt)}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="tabs-container d-flex justify-content-center mt-4">
          <div className="tabs-box d-flex">
            <div
              className={`tab-item ${activeTab === "orders" ? "active" : ""}`}
              onClick={() => handleTabClick("orders")}
            >
              Orders History
            </div>
            <div
              className={`tab-item ${activeTab === "coins" ? "active" : ""}`}
              onClick={() => handleTabClick("coins")}
            >
              Coins History
            </div>
            <div
              className={`tab-item ${activeTab === "approved" ? "active" : ""}`}
              onClick={() => handleTabClick("approved")}
            >
              Approved Medicines
            </div>
            <div
              className={`tab-item ${activeTab === "refill" ? "active" : ""}`}
              onClick={() => handleTabClick("refill")}
            >
              Refill Schedule
            </div>
          </div>
        </div>
        {activeTab === "orders" && <OrderHistory {...{ userId }} />}
        {activeTab === "coins" && <CoinHistory {...{ userId }} />}
        {activeTab === "approved" && <ApprovedMedicines {...{ userId }} />}
        {activeTab === "refill" && <RefillSchedule {...{ userId }} />}
      </div>
      {/* ------------------Change User Status*/}
      {statusModal && (
        <BlockUnblockUser
          selectedUserDetail={userDetail}
          onClose={() => closeModel()}
          fetchUserManagementList={fetchSelectedUserDetails}
          statusModal={statusModal}
        />
      )}
    </div>
  );
};

export default UserManagementDetails;
